import { render, staticRenderFns } from "./functionSettings.vue?vue&type=template&id=6355bc08&scoped=true"
import script from "./functionSettings.vue?vue&type=script&lang=js"
export * from "./functionSettings.vue?vue&type=script&lang=js"
import style0 from "./functionSettings.vue?vue&type=style&index=0&id=6355bc08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6355bc08",
  null
  
)

export default component.exports